import {useTranslation} from "react-i18next";
import {useMemo} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRefresh} from "@fortawesome/free-solid-svg-icons/faRefresh";
import {faCheck, faExclamationTriangle} from "@fortawesome/free-solid-svg-icons";
import moment from "moment-timezone";
import {useIsAdministrator} from "../../components/auth/rolesAndPermissions.js";

export default function IntegrationRow({row}) {

    let {t} = useTranslation();

    let isAdministrator = useIsAdministrator();

    let backgroundClass = useMemo(() => {
        switch (row.status) {
            case 'Failed':
                return 'bg-red-100 text-red-800 dark:bg-red-300 dark:text-red-700';
            case 'Scheduled':
                return 'bg-cyan-100 text-cyan-800 dark:bg-cyan-600 dark:text-cyan-100';
            case 'Running':
                return 'bg-cyan-100 text-cyan-800 dark:bg-cyan-600 dark:text-cyan-100';
            case 'Succeeded':
                return 'bg-green-100 text-green-800 dark:bg-green-300 dark:text-green-700';
        }

        return 'bg-white dark:bg-gray-800';
    }, [row]);

    let icon = useMemo(() => {
        switch (row.status) {
            case 'Failed':
                return faExclamationTriangle;
            case 'Scheduled':
                return faRefresh;
            case 'Running':
                return faRefresh;
            case 'Succeeded':
                return faCheck;
        }

        return faExclamationTriangle;
    }, [row]);

    return <div className={'rounded ' + backgroundClass + ' my-1 px-1'}>
        <div className={'flex gap-2 items-center'}>

            <div><FontAwesomeIcon icon={icon}/></div>
            <div>
                <img alt={'logo'} src={row.logoUrl} className={'rounded w-6 h-6'}/>
            </div>
            <div>{row.projectName}</div>
            <div>|</div>
            <div>{row.integrationName}</div>
            <div className={'text-xs opacity-50 ml-auto'}>
                <div> {t('project.last-refresh')}: {moment(row.lastSuccessfulUpdate).format('DD.MM.YYYY HH:mm')}</div>
                <div>{t('project.next-refresh')}: {moment(row.nextUpdate).format('DD.MM.YYYY HH:mm')}</div>
            </div>
        </div>

        <div className={'text-xs opacity-50'}>
            {row.integrationId}
        </div>

        {row.error && <div>{row.error}</div>}

    </div>;
}